import 'views/atoms/atoms-module';
import 'views/atoms/base-atom-view';
import 'views/atoms/button-atom/button-atom-view';
import 'views/atoms/icon-atom/icon-atom-view';
import 'views/atoms/link-atom/link-atom-view';
import 'views/atoms/control-bar-button-atom/control-bar-button-atom-view';
import 'views/atoms/control-bar-menu-atom/control-bar-menu-atom-view';
import 'views/atoms/locale-html-atom/locale-html-atom-view';
import 'views/atoms/locale-heading-atom/locale-heading-atom-view';
import 'views/atoms/tooltip-atom/tooltip-atom-view';
import 'views/atoms/image-atom/image-atom-view';
